import React, { useState, useEffect } from 'react';
import './BangChungXaHoi.css';

const BangChungXaHoi = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      name: 'Nguyễn Minh Tuấn',
      amount: '5,000,000đ',
      comment: 'Mới chơi lần đầu đã trúng 5 triệu! Rút tiền về tài khoản chỉ mất 3 phút. Game này uy tín thật sự, mọi người nên thử!',
      avatar: '👨'
    },
    {
      name: 'Trần Thị Hương',
      amount: '1,500,000đ',
      comment: 'Chơi được 3 ngày thì trúng 1.5 triệu. Không cần nạp tiền, quay miễn phí mà trúng được số tiền này thì quá may mắn rồi!',
      avatar: '👩'
    },
    {
      name: 'Lê Văn Đức',
      amount: '800,000đ',
      comment: 'Trúng 800k ngay lần quay đầu tiên. Rút về Momo luôn, không phải chờ đợi gì cả. Sẽ tiếp tục chơi mỗi ngày!',
      avatar: '👨'
    },
    {
      name: 'Phạm Thị Lan',
      amount: '10,000,000đ',
      comment: 'KHÔNG TIN NỔI! Trúng giải đặc biệt 10 triệu đồng! Đây là số tiền lớn nhất mình từng trúng. Cảm ơn game may mắn rất nhiều!',
      avatar: '👩'
    }
  ];

  const liveWinners = [
    { name: 'Nguyễn Văn Hùng', amount: '500,000đ', time: '1 phút trước' },
    { name: 'Trần Thị Mai', amount: '1,200,000đ', time: '3 phút trước' },
    { name: 'Lê Văn Nam', amount: '300,000đ', time: '5 phút trước' },
    { name: 'Phạm Thị Hoa', amount: '2,000,000đ', time: '7 phút trước' },
    { name: 'Hoàng Văn Long', amount: '800,000đ', time: '9 phút trước' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section className="social-proof">
      <div className="container">
        <h2 className="section-title">Người Chơi Thật Nói Gì Về Game May Mắn</h2>
        
        <div className="proof-content">
          <div className="testimonials-section">
            <div className="testimonial-card">
              <div className="testimonial-avatar">{testimonials[currentTestimonial].avatar}</div>
              <div className="testimonial-content">
                <div className="testimonial-amount">{testimonials[currentTestimonial].amount}</div>
                <p className="testimonial-comment">"{testimonials[currentTestimonial].comment}"</p>
                <div className="testimonial-author">- {testimonials[currentTestimonial].name}</div>
              </div>
              <div className="testimonial-indicators">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    className={`indicator ${index === currentTestimonial ? 'active' : ''}`}
                    onClick={() => setCurrentTestimonial(index)}
                    aria-label={`Xem đánh giá ${index + 1}`}
                    aria-current={index === currentTestimonial ? 'true' : 'false'}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="stats-section">
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-value">15 tỷ</div>
                <div className="stat-label">Tổng tiền thưởng đã trao</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">250,000+</div>
                <div className="stat-label">Người chơi đã tham gia</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">8,456</div>
                <div className="stat-label">Lượt quay hôm nay</div>
              </div>
            </div>

            <div className="live-feed">
              <h3 className="live-feed-title">🏆 Người thắng gần đây</h3>
              <div className="live-feed-list">
                {liveWinners.map((winner, index) => (
                  <div key={index} className="live-feed-item">
                    <span className="winner-name">{winner.name}</span>
                    <span className="winner-amount">{winner.amount}</span>
                    <span className="winner-time">{winner.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BangChungXaHoi;

